import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  caricamentoInCorso: false,
  labels: [],
  errore: null,
};

const labelsSlice = createSlice({
  name: 'labels',
  initialState,
  reducers: {
    caricamento(state, action) {
      state.caricamentoInCorso = Boolean(action.payload);
    },
    aggiornaLabels(state, action) {
      state.labels = action.payload;
    },
    errore(state, action) {
      state.errore = action.payload;
    },
    resetErrore(state) {
      state.errore = null;
    },
  },
});

export const { caricamento, aggiornaLabels, errore, resetErrore } = labelsSlice.actions;
const labelsReducer = labelsSlice.reducer;

export default labelsReducer;



